import FileApi from "api/clapaction/FileApi";
import { container, singleton } from "tsyringe";

@singleton()
export default class FileService {
	private api: FileApi = container.resolve(FileApi);

	public getFileUrl(folder: string, fileId: string): string {
		return this.api.getFileUrl(folder, fileId);
	}

	public async downloadFile(folder: string, fileId: string): Promise<Blob | null> {
		return this.api.downloadFile(folder, fileId).catch(() => null);
	}
}
